<app-i18n-dictionary>
    <span [attr.transid]="titleTextId" i18n="@@login-page_title">Login</span>
</app-i18n-dictionary>

<div i18n="@@login-page_headline" class="mat-display-3 title">B2B Login</div>

<div class="login-form" fxLayout="column" fxLayoutAlign="center center">
    <div class="content">
        <app-login-form (login)="onLogin($event)"
                        [pending]="isPending$ | async"
                        [authError]="authError$ | async">
        </app-login-form>
    </div>
</div>

<gallery fxHide.lt-md [loop]="true" [thumb]="false" [loadingStrategy]="'preload'" [gestures]="true"
         [autoPlay]="true" [playerInterval]="5000" [counter]="false" [imageSize]="'cover'"
         [items]="previewImages" [dots]="true" [nav]="false"
         class="image-gallery teaser-image"></gallery>
